module.exports = __webpack_public_path__ + "static/img/6.5a98fb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/6.jpg
// module id = 3uBk
// module chunks = 29